import { render, staticRenderFns } from "./JournalInfo.vue?vue&type=template&id=21f1ab0a&scoped=true"
import script from "./JournalInfo.vue?vue&type=script&lang=js"
export * from "./JournalInfo.vue?vue&type=script&lang=js"
import style0 from "./JournalInfo.vue?vue&type=style&index=0&id=21f1ab0a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f1ab0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f1ab0a')) {
      api.createRecord('21f1ab0a', component.options)
    } else {
      api.reload('21f1ab0a', component.options)
    }
    module.hot.accept("./JournalInfo.vue?vue&type=template&id=21f1ab0a&scoped=true", function () {
      api.rerender('21f1ab0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/JournalInfo.vue"
export default component.exports